module.exports = __webpack_public_path__ + "images/vgz_small1f251276be6424acc3621ac9aec0afb6.png";